import React from "react";
import { useFieldArray } from "react-hook-form";

import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import {
  Add as AddIcon,
  DeleteOutline as DeleteIcon,
} from "@mui/icons-material";

const AliasFields = ({ control, register, t }: any) => {
  const { fields, append, remove } = useFieldArray({
    name: "aliases",
    control,
  });

  const translate = (key: string, fallback: string) => {
    return typeof t === "function" ? t(key) : fallback;
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 2,
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1 }}
      >
        <Grid item>
          <Typography variant="h6" className="form-fields-title">
            {translate("aliases", "Aliases")}
          </Typography>
        </Grid>

        <Grid item>
          <Button
            type="button"
            size="small"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => append("")}
          >
            {translate("addAlias", "Add alias")}
          </Button>
        </Grid>
      </Grid>

      <Box
        sx={{
          maxHeight: {
            xs: 220,
            md: 260,
          },
          overflow: "auto",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1.5,
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{translate("alias", "Alias")}</TableCell>
              <TableCell align="right" sx={{ width: 90 }}>
                {translate("actions", "Actions")}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {fields.map((field, index) => (
              <TableRow key={field.id}>
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder={translate("alias", "Alias")}
                    {...register(`aliases.${index}`)}
                  />
                </TableCell>

                <TableCell align="right">
                  <IconButton
                    type="button"
                    size="small"
                    color="error"
                    onClick={() => remove(index)}
                  >
                    <DeleteIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {fields.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    textAlign="center"
                    sx={{ py: 2 }}
                  >
                    {translate("noAliasesForTerminal", "No aliases available.")}
                  </Typography>

                  <Box display="flex" justifyContent="center" pb={1}>
                    <Button
                      type="button"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => append("")}
                    >
                      {translate("addAlias", "Add alias")}
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
};

export default AliasFields;